module.exports = __webpack_public_path__ + "static/img/tkdds.9f41ea7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/tkdds.png
// module id = vtYF
// module chunks = 1